<template>
    <div class="automation-action-settings">
        <div class="field">
            <label>{{ t('automations-form-actions-data_sets-dataset_label') }}</label>
            <select v-model="selectedDataSet" class="form-control">
                <option v-for="dataSet in dataSets" :key="dataSet.id" :value="dataSet.id">
                    {{ dataSet.name }}
                </option>
            </select>
        </div>
        <div class="field" v-if="selectedDataSet">
            <label>{{ t('automations-form-actions-data_sets-selection_mode_label') }}</label>
            <div class="selection-mode pt-2">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="keySelectionMode" id="aiMode" value="ai" v-model="keySelectionMode">
                    <label class="form-check-label" for="aiMode">{{ t('automations-form-actions-data_sets-selection_modes-ai') }}</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="keySelectionMode" id="manualMode" value="manual" v-model="keySelectionMode">
                    <label class="form-check-label" for="manualMode">{{ t('automations-form-actions-data_sets-selection_modes-manual') }}</label>
                </div>

            </div>
        </div>

        <div class="field" v-if="selectedDataSet && keySelectionMode === 'manual'">
            <label>{{ t('automations-form-actions-data_sets-key_label') }}</label>
            <input type="text" class="form-control" v-model="selectedDataSetKey" />
            <div>
                <small>
                    {{ t('automations-form-actions-data_sets-snippets_help') }}
                </small>
                <small>
                    <ul>
                        <li class="token" v-for="(token, t) in availableTokens" :key="t">
                            <span class="copy-token">{{ token }}</span>
                            <a @click="copyToken(token)" class="copy-btn"><i class="fa fa-copy"></i></a>
                        </li>
                    </ul>
                </small>
            </div>
        </div>

        <div class="field" v-if="selectedDataSet && keySelectionMode === 'ai'">
            <div>
                <div class="badge badge-primary" v-html="t('automations-form-actions-data_sets-ai_credits', [0.2])"></div>
            </div>
            <label>{{ t('automations-form-actions-data_sets-ai_prompt_label') }}</label>
            <textarea class="form-control" v-model="aiPrompt" rows="3" :placeholder="t('automations-form-actions-data_sets-ai_prompt_placeholder')"></textarea>
            <small class="text-muted">{{ t('automations-form-actions-data_sets-ai_prompt_help') }}</small>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.selection-mode {
    margin-bottom: 15px;
}
</style>

<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        properties: Object,
        actionId: String,
    },
    data() {
        return {
            title: this.t("automations-form-actions-data_sets-title"),
            description: this.t("automations-form-actions-data_sets-description"),
            dataSets: [],
            selectedDataSet: this.properties?.selectedDataSet || null,
            selectedDataSetKey: this.properties?.selectedDataSetKey || null,
            keySelectionMode: this.properties?.keySelectionMode || "ai",
            aiPrompt: this.properties?.aiPrompt || "",
            tokens: [],
        };
    },
    computed: {
        availableTokens: function () {
            return this.$store.getters["automationForm/tokens"](this.actionId);
        },
    },
    mounted() {
        this.$emit("mounted", this);
        const options = keviApi.getOptions("data-sets");
        this.$http(options).then(response => {
            this.dataSets = Object.values(response.data.dataSets);
            this.changed();
        });
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        changed() {
            const dataSet = this.dataSets.find(dataSet => dataSet.id === this.selectedDataSet);
            this.tokens = dataSet?.tokens || [];
            this.$emit("propertiesUpdated", {
                selectedDataSet: this.selectedDataSet,
                selectedDataSetKey: this.selectedDataSetKey,
                keySelectionMode: this.keySelectionMode,
                aiPrompt: this.aiPrompt,
                tokens: this.tokens,
            });
        },
        isValid() {
            if (this.selectedDataSet === null || isNaN(this.selectedDataSet)) {
                return false;
            }

            if (this.keySelectionMode === "manual") {
                return this.selectedDataSetKey !== null && this.selectedDataSetKey !== "";
            } else if (this.keySelectionMode === "ai") {
                return this.aiPrompt !== null && this.aiPrompt !== "";
            }

            return false;
        },
        copyToken(token) {
            // Copy token to clipboard functionality should be here
            if (this.keySelectionMode === "manual") {
                this.selectedDataSetKey += token;
            } else {
                this.aiPrompt += token;
            }
        }
    },
    watch: {
        selectedDataSet() {
            this.changed();
        },
        selectedDataSetKey() {
            this.changed();
        },
        keySelectionMode() {
            this.changed();
        },
        aiPrompt() {
            this.changed();
        }
    },
};
</script>
